<div class="container">
  <div class="text-center mt-4">
    <img id="logo" class="img-fluid" src="images/akvarium_logo.svg">
  </div>
  <div *ngIf="session && session.status === 'active' && !confirmation">
    <div class="text-center mt-5">
      <p *ngIf="session.beforeFirstOpen" class="lead text-primary fw-bold" translate>
        OPEN.LEAD_BFO
      </p>
      <p *ngIf="!session.beforeFirstOpen" class="lead text-primary fw-bold" translate>
        OPEN.LEAD
      </p>
      <p class="fw-bold size-extreme">
        {{session.box.displayName}}
      </p>
    </div>
    <div *ngIf="session.beforeFirstOpen" class="text-center mt-4 mb-5 mx-4">
      <button
        type="button" class="btn btn-dark btn-lg w-100"
        (click)="openBox(false)" [disabled]="inProgress">
        <span *ngIf="!inProgress" translate>OPEN.BTN_OPEN_BFO</span>
        <span *ngIf="inProgress" class="spinner-border" aria-hidden="true"></span>
      </button>
      <p class="text-start lead mt-5" translate>
        OPEN.DESC_OPEN_BFO
      </p>
    </div>
    <div *ngIf="!session.beforeFirstOpen" class="text-center mt-4 mb-5 mx-4">
      <p class="text-start lead text-primary mx-4" translate>
        OPEN.DESC_OPEN_ONLY
      </p>
      <button type="button" class="btn btn-dark btn-lg w-100"
        (click)="openBox(false)" [disabled]="inProgress">
        <span *ngIf="!inProgress" translate>OPEN.BTN_OPEN_ONLY</span>
        <span *ngIf="inProgress" class="spinner-border" aria-hidden="true"></span>
      </button>
    </div>
    <div *ngIf="!session.beforeFirstOpen" class="text-center mt-4 mb-5 mx-4">
      <p class="text-start lead text-primary mx-4" translate>
        OPEN.DESC_OPEN_END_RES
      </p>
      <button type="button" class="btn btn-dark btn-lg w-100"
        (click)="askForConfirmation()" [disabled]="inProgress">
        <span translate>OPEN.BTN_OPEN_END_RES</span>
      </button>
    </div>
  </div>
  <div *ngIf="session && session.status === 'active' && confirmation">
    <div class="text-center mt-5">
      <p class="lead text-primary fw-bold" translate>
        OPEN.LEAD_CONFIRMATION_1
      </p>
      <p class="lead text-primary fw-bold" translate>
        OPEN.LEAD_CONFIRMATION_2
      </p>
      <button type="button" class="btn btn-dark btn-lg w-100 mt-3"
        (click)="openBox(true)" [disabled]="inProgress">
        <span *ngIf="!inProgress" translate>OPEN.BTN_OPEN_END_RES</span>
        <span *ngIf="inProgress" class="spinner-border" aria-hidden="true"></span>
      </button>
      <button type="button" class="btn btn-light btn-lg w-100 mt-3"
        (click)="declineConfirmation()" [disabled]="inProgress">
        <span translate>OPEN.BTN_CANCEL</span>
      </button>
    </div>
  </div>
  <div *ngIf="session && session.status === 'ended'">
    <div class="text-center mt-5">
      <p class="lead text-primary fw-bold" translate>
        OPEN.LEAD_LEASE_ENDED_1
      </p>
      <p class="lead text-primary fw-bold" translate>
        OPEN.LEAD_LEASE_ENDED_2
      </p>
      <p class="lead text-primary fw-bold" translate>
        OPEN.LEAD_LEASE_ENDED_3
      </p>
    </div>
  </div>
</div>
